import { IntlFormatters } from "react-intl";
import { rhytPatterns } from "../parameters";

export default (fm: IntlFormatters["formatMessage"]) => {
    const patterns: {label: string, value: string }[] = [];
    Object.keys(rhytPatterns(fm)).forEach(key => {
        patterns.push({
            label: rhytPatterns(fm)[key],
            value: key,
        });
    });
    return patterns;
};
